export default __webpack_public_path__ + "static/media/ganador.2d94dc48.svg";